import React, { useEffect } from "react";
import { connect } from "react-redux";
import Divider from "@mui/material/Divider";
import { generateDebtPanel } from "../../../../store/modules/dealOffer/actions";
import Item from "../InputItem";

function DealOfferSummary({
  dealType,
  currentLBODashboard,
  debtPanel,
  dispatchGenerateDebtPanel
}) {
  // Mounted
  useEffect(() => {
    dispatchGenerateDebtPanel(dealType);
  }, []);

  return (
    <div className="flex flex-wrap justify-center" style={{ minWidth: 700 }}>
      {debtPanel &&
        (<div className="inline-block w-full max-w-3xl border border-neutral-200 p-10 box-content mt-10">
          <Item name="Purchase Price" data={currentLBODashboard.summaryPurchasePrice} disabled={true} />
          <Item name="(-) Debt Assumed" data={currentLBODashboard.debtAssumed} disabled={true} />
          <Item name="Balance of Equity Owed" data={currentLBODashboard.summaryBalanceOfEquity} disabled={true} />
          <Item name="Percent Paid at Closing" data={currentLBODashboard.summaryPercentPaid} endLabel="%" disabled={true} />
          <Divider />
          <Item name="Down Payment at Closing" data={currentLBODashboard.summaryDownPayment} disabled={true} bold={true} />
          
          <div style={{ height: 15 }} />
          <Item name="Financing" data={currentLBODashboard.summaryFinancing} disabled={true} />
          <Item name="Interest Rate" data={currentLBODashboard.interestRate} endLabel="%" disabled={true} />
          <Item name="Amortized over" data={currentLBODashboard.amortizedOver} endLabel="Months" disabled={true} />
          <Item name="With Monthly Payments of" data={debtPanel.debtAndCashEngine?.ownerFinancing.monthlyPayments} disabled={true} />
          {debtPanel.debtAndCashEngine?.ownerFinancing.balloonPayment < 0.01 ?
            <></>
            :
            <>
              <Item name="Balloon Payment after" data={currentLBODashboard.balloonPaymentAfter} endLabel="Months" disabled={true} />
              <Item name="Final Balloon Payment" data={debtPanel.debtAndCashEngine?.ownerFinancing.balloonPayment} disabled={true} />
            </>
          }
          <Item name="Cash Sweep Total" data={debtPanel.debtAndCashEngine?.ownerFinancing.cashSweepTotal} disabled={true} />
          <Divider />
          <Item name="Total Interest Paid to Seller" data={debtPanel.debtAndCashEngine?.ownerFinancing.totalInterest} disabled={true} bold={true} />
          
          <div style={{ height: 15 }} />
          <div className="flex justify-between items-center my-3 px-5">
            <div className="items-center text-lg">Earnout Target</div>
            <div className="items-center text-center text-xl font-semibold w-44">{currentLBODashboard.earnoutTarget}</div>
          </div>
          <Item name="Earnout Target Amount" data={currentLBODashboard.earnoutTargetAmount} disabled={true} />
          <Item name="Number of Earnout Years" data={currentLBODashboard.earnoutYears} disabled={true} />
          <Item name="Compensation (Annual)" data={currentLBODashboard.compensation} disabled={true} />
          <Divider />
          <Item name="Earnout Target Total" data={currentLBODashboard.earnoutTargetTotal} disabled={true} bold={true} />
          
          <div style={{ height: 15 }} />
          <Item name="Consulting Fee (Monthly)" data={currentLBODashboard.consultingFee} disabled={true} />
          <Item name="Consulting Period in Months" data={currentLBODashboard.consultingPeriod} disabled={true} />
          <Divider />
          <Item name="Consulting Payment Totals" data={currentLBODashboard.consultingPaymentTotal} disabled={true} bold={true} />
          
          <div style={{ height: 15 }} />
          <Item
            name="Total Payments Paid to Seller"
            data={
              currentLBODashboard.summaryFinancing +
              debtPanel.debtAndCashEngine?.ownerFinancing.totalInterest +
              currentLBODashboard.earnoutTargetTotal +
              currentLBODashboard.consultingPaymentTotal
            }
            disabled={true}
            bold={true}
            bg="bg-neutral-100"
          />
          <Item
            name="Total Deal Consideration"
            data={
              currentLBODashboard.summaryBalanceOfEquity +
              debtPanel.debtAndCashEngine?.ownerFinancing.totalInterest +
              currentLBODashboard.earnoutTargetTotal +
              currentLBODashboard.consultingPaymentTotal
            }
            disabled={true}
            bold={true}
            bg="bg-neutral-200"
          />
        </div>)
      }
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentLBODashboard: state.dealOffer.currentLBODashboard,
  debtPanel: state.dealOffer.debtPanel,
});

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateDebtPanel(dealType) {
    await dispatch(generateDebtPanel(dealType));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DealOfferSummary);
